import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Hero from "@/components/landing/Hero";
import WeeklyMenu from "@/components/landing/WeeklyMenu";
import WeeklyPlans from "@/components/landing/WeeklyPlans";
import FamilyMeals from "@/components/landing/FamilyMeals";
import BuiltFor from "@/components/landing/BuiltFor";
import VolumePricing from "@/components/landing/VolumePricing";
import Footer from "@/components/landing/Footer";
import HeaderBar from "@/auth/HeaderBar";
import { useCart } from "@/cart/CartProvider";

export default function Landing() {
    const navigate = useNavigate();
    const { meals, familyConfig, openAuth } = useCart();

    // Reveal-on-scroll
    useEffect(() => {
        const els = document.querySelectorAll(".reveal");
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting) {
                        e.target.classList.add("is-visible");
                        io.unobserve(e.target);
                    }
                });
            },
            { threshold: 0.12 }
        );
        els.forEach((el) => io.observe(el));
        return () => io.disconnect();
    }, [meals]);

    // Homepage = showcase only. Every "add to order" interaction routes the
    // customer to /menu, which is the single ordering hub.
    const goToFullMenu = (mealId) => {
        navigate(`/menu${mealId ? `#${mealId}` : ""}`);
    };

    return (
        <div className="min-h-screen bg-cream text-navy font-sans">
            <HeaderBar onSignIn={openAuth} dark />
            <Hero onSeeMenu={() => navigate("/menu")} />
            <WeeklyMenu
                meals={meals}
                cart={{}}
                onQtyChange={(id) => goToFullMenu(id)}
                onMealImageClick={goToFullMenu}
                showcaseMode
            />
            <VolumePricing onCta={() => navigate("/menu")} />
            <BuiltFor />
            <WeeklyPlans onStart={() => navigate("/menu")} />
            <FamilyMeals
                config={familyConfig}
                meals={meals}
                onAdd={null}
                showcaseMode
                onCtaToMenu={() => goToFullMenu()}
            />
            <Footer />
        </div>
    );
}
